module.exports = __webpack_public_path__ + "static/media/minimize.5a7b7abc.svg";